import React from 'react'
import { Textarea as UITextarea } from '@/components/ui/textarea'
import { cn } from '@/lib/utils'

// The shadcn Textarea auto-grows via field-sizing:content, which replaces
// the legacy `expands` JS resize behaviour.
class Textarea extends React.Component {

  setInput = (el) => {
    this.input = el
    if (this.props.inputRef) {
      this.props.inputRef(el)
    }
  }

  // Some callers attach string refs to this wrapper (e.g. tutor_proposer's
  // ref="motivation"); expose value/focus so instance access keeps working.
  get value() {
    return this.input ? this.input.value : undefined
  }

  focus() {
    if (this.input) {
      this.input.focus()
    }
  }

  onChange = () => {
    if (this.props.onChange) {
      this.props.onChange(this.input.value)
    }
  }

  onKeyDown = (e) => {
    if (this.props.onKeyDown) {
      this.props.onKeyDown(e)
    }

    if (e.key === 'Backspace') {
      if (this.props.value === '') {
        if (this.props.onClear) {
          this.props.onClear()
        }
      }
    }
    else if (e.key === 'Enter') {
      if (this.props.onEnter) {
        this.props.onEnter(e)
      }
    }
  }

  onBlur = () => {
    if (this.props.onBlur) {
      this.props.onBlur(this.input.value)
    }
  }

  render() {
    // Strip the legacy bootstrap default; anything else passes through.
    const classes = (this.props.classNames || '')
      .split(/\s+/)
      .filter((token) => token && token !== 'form-control')

    const rows = parseInt(this.props.rows || '6', 10)

    return (
      <UITextarea
        rows={rows}
        // field-sizing:content ignores the rows attribute, so translate it
        // into the starting height (1lh per row + py-3 padding) — via a class
        // so callers (e.g. the task rows) can still override it. resize-y
        // restores the native drag handle legacy textareas always had.
        style={{ '--rows': rows }}
        className={cn('min-h-[calc(var(--rows)*1lh+1.5rem)] resize-y', classes)}
        placeholder={this.props.placeholder}
        ref={this.setInput}
        value={this.props.value}
        onChange={this.onChange}
        onKeyDown={this.onKeyDown}
        onBlur={this.onBlur}
      />
    )
  }
}

export default Textarea
